<div class="row ">
  <div class="container " #container style="padding-right: 0;padding-left: 0">
    <div class="left" *ngIf="totalPages > 1" (click)="currentPage != 1 && changePage(-1)"
         [ngClass]="{'disabled':currentPage === 1,'mct':this.className === 'mini-card'}">
      <svg height="18" width="18" fill="currentColor" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.236 14.646L5 9l6.275-5.689a1 1 0 011.482 1.342L8 9l4.699 4.285c.187.2.301.435.301.715a1 1 0 01-1 1c-.306 0-.537-.151-.764-.354z"></path>
      </svg>
    </div>

    <div class="cards" [ngClass]="{'w-100': totalPages === 1}">
      <div class="overflow" [ngStyle]="{'width': overflowWidth, 'left': pagePosition}">
        <div [class]="this.className" *ngFor="let item of arr; let index = index" [ngStyle]="{'width': cardWidth}">

          <img [src]="item.base64" [title]="item.title" style="width:100%;cursor: pointer" (click)="loadData(item.id)">
          <div class="">
            <p class="p-1" [ngStyle]="{'text-align':apiService.currentDirection==='rtl'? 'right' : 'left'}">
              <b>{{item.title}}</b></p>
            <!--            <p>{{i.content}}</p>-->
            <!--            <a href="https://www.alobodo.com">{{i.link}}</a>-->
            <!--          <span>{{i}}</span>-->
          </div>

          <!--        -->
          <!--        <p>hhfdjhdfj</p>-->
          <!--        <img src="../../../assets/img/AppStore1.png" style="width: 100%; height: 40px"/>-->

        </div>
      </div>
    </div>

    <div class="right" *ngIf="totalPages > 1" (click)="currentPage != totalPages && changePage(+1)"
         [ngClass]="{'disabled':currentPage === totalPages,'mct':this.className === 'mini-card'}">
      <svg height="18" width="18" fill="currentColor" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.764 14.646L13 9 6.725 3.311a1 1 0 00-1.482 1.342L10 9l-4.699 4.285c-.187.2-.301.435-.301.715a1 1 0 001 1c.306 0 .537-.151.764-.354z"></path>
      </svg>
    </div>
  </div>
</div>
